/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PrivateRouteRouteImport } from './routes/_private/route'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PrivateStatsRouteImport } from './routes/_private/stats'
import { Route as PrivateAuditLogsRouteImport } from './routes/_private/audit-logs'
import { Route as PrivateUsersIndexRouteImport } from './routes/_private/users/index'
import { Route as PrivateTransactionsIndexRouteImport } from './routes/_private/transactions/index'
import { Route as PrivatePreferencesIndexRouteImport } from './routes/_private/preferences/index'
import { Route as PrivateClientsIndexRouteImport } from './routes/_private/clients/index'
import { Route as PrivateChargesIndexRouteImport } from './routes/_private/charges/index'
import { Route as PublicAuthCallbackRouteImport } from './routes/_public/auth/callback'
import { Route as PrivateUsersUserIdRouteRouteImport } from './routes/_private/users/$userId/route'
import { Route as PrivateClientsClientIdRouteRouteImport } from './routes/_private/clients/$clientId/route'
import { Route as PrivateUsersUserIdIndexRouteImport } from './routes/_private/users/$userId/index'
import { Route as PrivateTransactionsTransactionIdIndexRouteImport } from './routes/_private/transactions/$transactionId/index'
import { Route as PrivatePreferencesPreferenceIdIndexRouteImport } from './routes/_private/preferences/$preferenceId/index'
import { Route as PrivateClientsClientIdIndexRouteImport } from './routes/_private/clients/$clientId/index'
import { Route as PrivateUsersUserIdChargesRouteImport } from './routes/_private/users/$userId/charges'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicTermsRoute = PublicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateStatsRoute = PrivateStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateAuditLogsRoute = PrivateAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateUsersIndexRoute = PrivateUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateTransactionsIndexRoute =
  PrivateTransactionsIndexRouteImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivatePreferencesIndexRoute = PrivatePreferencesIndexRouteImport.update({
  id: '/preferences/',
  path: '/preferences/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateClientsIndexRoute = PrivateClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateChargesIndexRoute = PrivateChargesIndexRouteImport.update({
  id: '/charges/',
  path: '/charges/',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PublicAuthCallbackRoute = PublicAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateUsersUserIdRouteRoute = PrivateUsersUserIdRouteRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateClientsClientIdRouteRoute =
  PrivateClientsClientIdRouteRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateUsersUserIdIndexRoute = PrivateUsersUserIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateUsersUserIdRouteRoute,
} as any)
const PrivateTransactionsTransactionIdIndexRoute =
  PrivateTransactionsTransactionIdIndexRouteImport.update({
    id: '/transactions/$transactionId/',
    path: '/transactions/$transactionId/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivatePreferencesPreferenceIdIndexRoute =
  PrivatePreferencesPreferenceIdIndexRouteImport.update({
    id: '/preferences/$preferenceId/',
    path: '/preferences/$preferenceId/',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateClientsClientIdIndexRoute =
  PrivateClientsClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateClientsClientIdRouteRoute,
  } as any)
const PrivateUsersUserIdChargesRoute =
  PrivateUsersUserIdChargesRouteImport.update({
    id: '/charges',
    path: '/charges',
    getParentRoute: () => PrivateUsersUserIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/audit-logs': typeof PrivateAuditLogsRoute
  '/stats': typeof PrivateStatsRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/': typeof PublicIndexRoute
  '/clients/$clientId': typeof PrivateClientsClientIdRouteRouteWithChildren
  '/users/$userId': typeof PrivateUsersUserIdRouteRouteWithChildren
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/charges': typeof PrivateChargesIndexRoute
  '/clients': typeof PrivateClientsIndexRoute
  '/preferences': typeof PrivatePreferencesIndexRoute
  '/transactions': typeof PrivateTransactionsIndexRoute
  '/users': typeof PrivateUsersIndexRoute
  '/users/$userId/charges': typeof PrivateUsersUserIdChargesRoute
  '/clients/$clientId/': typeof PrivateClientsClientIdIndexRoute
  '/preferences/$preferenceId': typeof PrivatePreferencesPreferenceIdIndexRoute
  '/transactions/$transactionId': typeof PrivateTransactionsTransactionIdIndexRoute
  '/users/$userId/': typeof PrivateUsersUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/audit-logs': typeof PrivateAuditLogsRoute
  '/stats': typeof PrivateStatsRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/terms': typeof PublicTermsRoute
  '/': typeof PublicIndexRoute
  '/auth/callback': typeof PublicAuthCallbackRoute
  '/charges': typeof PrivateChargesIndexRoute
  '/clients': typeof PrivateClientsIndexRoute
  '/preferences': typeof PrivatePreferencesIndexRoute
  '/transactions': typeof PrivateTransactionsIndexRoute
  '/users': typeof PrivateUsersIndexRoute
  '/users/$userId/charges': typeof PrivateUsersUserIdChargesRoute
  '/clients/$clientId': typeof PrivateClientsClientIdIndexRoute
  '/preferences/$preferenceId': typeof PrivatePreferencesPreferenceIdIndexRoute
  '/transactions/$transactionId': typeof PrivateTransactionsTransactionIdIndexRoute
  '/users/$userId': typeof PrivateUsersUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_private/audit-logs': typeof PrivateAuditLogsRoute
  '/_private/stats': typeof PrivateStatsRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/terms': typeof PublicTermsRoute
  '/_public/': typeof PublicIndexRoute
  '/_private/clients/$clientId': typeof PrivateClientsClientIdRouteRouteWithChildren
  '/_private/users/$userId': typeof PrivateUsersUserIdRouteRouteWithChildren
  '/_public/auth/callback': typeof PublicAuthCallbackRoute
  '/_private/charges/': typeof PrivateChargesIndexRoute
  '/_private/clients/': typeof PrivateClientsIndexRoute
  '/_private/preferences/': typeof PrivatePreferencesIndexRoute
  '/_private/transactions/': typeof PrivateTransactionsIndexRoute
  '/_private/users/': typeof PrivateUsersIndexRoute
  '/_private/users/$userId/charges': typeof PrivateUsersUserIdChargesRoute
  '/_private/clients/$clientId/': typeof PrivateClientsClientIdIndexRoute
  '/_private/preferences/$preferenceId/': typeof PrivatePreferencesPreferenceIdIndexRoute
  '/_private/transactions/$transactionId/': typeof PrivateTransactionsTransactionIdIndexRoute
  '/_private/users/$userId/': typeof PrivateUsersUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/audit-logs'
    | '/stats'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/'
    | '/clients/$clientId'
    | '/users/$userId'
    | '/auth/callback'
    | '/charges'
    | '/clients'
    | '/preferences'
    | '/transactions'
    | '/users'
    | '/users/$userId/charges'
    | '/clients/$clientId/'
    | '/preferences/$preferenceId'
    | '/transactions/$transactionId'
    | '/users/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/audit-logs'
    | '/stats'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/'
    | '/auth/callback'
    | '/charges'
    | '/clients'
    | '/preferences'
    | '/transactions'
    | '/users'
    | '/users/$userId/charges'
    | '/clients/$clientId'
    | '/preferences/$preferenceId'
    | '/transactions/$transactionId'
    | '/users/$userId'
  id:
    | '__root__'
    | '/_private'
    | '/_public'
    | '/_private/audit-logs'
    | '/_private/stats'
    | '/_public/login'
    | '/_public/privacy'
    | '/_public/terms'
    | '/_public/'
    | '/_private/clients/$clientId'
    | '/_private/users/$userId'
    | '/_public/auth/callback'
    | '/_private/charges/'
    | '/_private/clients/'
    | '/_private/preferences/'
    | '/_private/transactions/'
    | '/_private/users/'
    | '/_private/users/$userId/charges'
    | '/_private/clients/$clientId/'
    | '/_private/preferences/$preferenceId/'
    | '/_private/transactions/$transactionId/'
    | '/_private/users/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/terms': {
      id: '/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicTermsRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/stats': {
      id: '/_private/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof PrivateStatsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/audit-logs': {
      id: '/_private/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof PrivateAuditLogsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/users/': {
      id: '/_private/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof PrivateUsersIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/transactions/': {
      id: '/_private/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof PrivateTransactionsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/preferences/': {
      id: '/_private/preferences/'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof PrivatePreferencesIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/clients/': {
      id: '/_private/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof PrivateClientsIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/charges/': {
      id: '/_private/charges/'
      path: '/charges'
      fullPath: '/charges'
      preLoaderRoute: typeof PrivateChargesIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_public/auth/callback': {
      id: '/_public/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof PublicAuthCallbackRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/users/$userId': {
      id: '/_private/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof PrivateUsersUserIdRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/clients/$clientId': {
      id: '/_private/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof PrivateClientsClientIdRouteRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/users/$userId/': {
      id: '/_private/users/$userId/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof PrivateUsersUserIdIndexRouteImport
      parentRoute: typeof PrivateUsersUserIdRouteRoute
    }
    '/_private/transactions/$transactionId/': {
      id: '/_private/transactions/$transactionId/'
      path: '/transactions/$transactionId'
      fullPath: '/transactions/$transactionId'
      preLoaderRoute: typeof PrivateTransactionsTransactionIdIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/preferences/$preferenceId/': {
      id: '/_private/preferences/$preferenceId/'
      path: '/preferences/$preferenceId'
      fullPath: '/preferences/$preferenceId'
      preLoaderRoute: typeof PrivatePreferencesPreferenceIdIndexRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/clients/$clientId/': {
      id: '/_private/clients/$clientId/'
      path: '/'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof PrivateClientsClientIdIndexRouteImport
      parentRoute: typeof PrivateClientsClientIdRouteRoute
    }
    '/_private/users/$userId/charges': {
      id: '/_private/users/$userId/charges'
      path: '/charges'
      fullPath: '/users/$userId/charges'
      preLoaderRoute: typeof PrivateUsersUserIdChargesRouteImport
      parentRoute: typeof PrivateUsersUserIdRouteRoute
    }
  }
}

interface PrivateClientsClientIdRouteRouteChildren {
  PrivateClientsClientIdIndexRoute: typeof PrivateClientsClientIdIndexRoute
}

const PrivateClientsClientIdRouteRouteChildren: PrivateClientsClientIdRouteRouteChildren =
  {
    PrivateClientsClientIdIndexRoute: PrivateClientsClientIdIndexRoute,
  }

const PrivateClientsClientIdRouteRouteWithChildren =
  PrivateClientsClientIdRouteRoute._addFileChildren(
    PrivateClientsClientIdRouteRouteChildren,
  )

interface PrivateUsersUserIdRouteRouteChildren {
  PrivateUsersUserIdChargesRoute: typeof PrivateUsersUserIdChargesRoute
  PrivateUsersUserIdIndexRoute: typeof PrivateUsersUserIdIndexRoute
}

const PrivateUsersUserIdRouteRouteChildren: PrivateUsersUserIdRouteRouteChildren =
  {
    PrivateUsersUserIdChargesRoute: PrivateUsersUserIdChargesRoute,
    PrivateUsersUserIdIndexRoute: PrivateUsersUserIdIndexRoute,
  }

const PrivateUsersUserIdRouteRouteWithChildren =
  PrivateUsersUserIdRouteRoute._addFileChildren(
    PrivateUsersUserIdRouteRouteChildren,
  )

interface PrivateRouteRouteChildren {
  PrivateAuditLogsRoute: typeof PrivateAuditLogsRoute
  PrivateStatsRoute: typeof PrivateStatsRoute
  PrivateClientsClientIdRouteRoute: typeof PrivateClientsClientIdRouteRouteWithChildren
  PrivateUsersUserIdRouteRoute: typeof PrivateUsersUserIdRouteRouteWithChildren
  PrivateChargesIndexRoute: typeof PrivateChargesIndexRoute
  PrivateClientsIndexRoute: typeof PrivateClientsIndexRoute
  PrivatePreferencesIndexRoute: typeof PrivatePreferencesIndexRoute
  PrivateTransactionsIndexRoute: typeof PrivateTransactionsIndexRoute
  PrivateUsersIndexRoute: typeof PrivateUsersIndexRoute
  PrivatePreferencesPreferenceIdIndexRoute: typeof PrivatePreferencesPreferenceIdIndexRoute
  PrivateTransactionsTransactionIdIndexRoute: typeof PrivateTransactionsTransactionIdIndexRoute
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateAuditLogsRoute: PrivateAuditLogsRoute,
  PrivateStatsRoute: PrivateStatsRoute,
  PrivateClientsClientIdRouteRoute:
    PrivateClientsClientIdRouteRouteWithChildren,
  PrivateUsersUserIdRouteRoute: PrivateUsersUserIdRouteRouteWithChildren,
  PrivateChargesIndexRoute: PrivateChargesIndexRoute,
  PrivateClientsIndexRoute: PrivateClientsIndexRoute,
  PrivatePreferencesIndexRoute: PrivatePreferencesIndexRoute,
  PrivateTransactionsIndexRoute: PrivateTransactionsIndexRoute,
  PrivateUsersIndexRoute: PrivateUsersIndexRoute,
  PrivatePreferencesPreferenceIdIndexRoute:
    PrivatePreferencesPreferenceIdIndexRoute,
  PrivateTransactionsTransactionIdIndexRoute:
    PrivateTransactionsTransactionIdIndexRoute,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicTermsRoute: typeof PublicTermsRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicAuthCallbackRoute: typeof PublicAuthCallbackRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicTermsRoute: PublicTermsRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicAuthCallbackRoute: PublicAuthCallbackRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
